import { render, staticRenderFns } from "./MarketTable.vue?vue&type=template&id=f531cf6e&scoped=true&"
import script from "./MarketTable.vue?vue&type=script&lang=js&"
export * from "./MarketTable.vue?vue&type=script&lang=js&"
import style0 from "./MarketTable.vue?vue&type=style&index=0&id=f531cf6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f531cf6e",
  null
  
)

export default component.exports